import { Fragment } from 'react';
import { QueryClientProvider } from 'react-query';
import { CookiesProvider } from 'react-cookie';
import { AppProps } from 'next/app';
import Head from 'next/head';

import { Core } from '@reckon-web/core';
import { ToastProvider } from '@reckon-web/toast';
import { ErrorBoundaryProvider } from '@reckon-web/error-boundary';
import { UniversalNextLink } from '@reckon-web/next-link';

import { IdContextProvider } from '../context';
import { queryClient } from '../services/queryClient';

export default function App({ Component, pageProps }: AppProps) {
  const isNewDomain =
    typeof window !== 'undefined' &&
    window.location.origin.includes('access-aps');

  process.env.oauthRedirectSignIn = isNewDomain
    ? process.env.oauthRedirectSignInNew
    : process.env.oauthRedirectSignInOld;
  process.env.oauthRedirectSignOut = isNewDomain
    ? process.env.oauthRedirectSignOutNew
    : process.env.oauthRedirectSignOutOld;
  process.env.authBackend = isNewDomain
    ? process.env.authBackendNew
    : process.env.authBackendOld;

  return (
    <QueryClientProvider client={queryClient}>
      <Fragment>
        <Head>
          <script src="polyfill.min.js" />
        </Head>
        <Core linkComponent={UniversalNextLink}>
          <CookiesProvider>
            <ErrorBoundaryProvider>
              <ToastProvider>
                <Head>
                  {/* Global Site Tag (gtag.js) - Google Analytics */}
                  <script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${process.env.GTagId}`}
                  />
                  <script
                    dangerouslySetInnerHTML={{
                      __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${process.env.GTagId}', {
              page_path: window.location.pathname,
            });
          `,
                    }}
                  />
                </Head>
                <IdContextProvider>
                  <Component {...pageProps} />
                </IdContextProvider>
              </ToastProvider>
            </ErrorBoundaryProvider>
          </CookiesProvider>
        </Core>
      </Fragment>
    </QueryClientProvider>
  );
}
